import React from 'react';
import './ProcessStep.css';



const ProcessStep = ({step}) => {

  // Destructuring props
  const { id, image, title, content } = step;

  return (

    <div className='process-item' key={id}>

      <div className='image'>
        <img src={image} alt={title} /> {/* Step Image */}
        <span className='step-no'>0{id}</span> {/* Step Number */}
      </div>

      <div className='content'>
        <h3>{title}</h3> {/* Step Title */}
        <p>{content}</p> {/* Step Content */}
      </div>

    </div>

  );
};

export default ProcessStep;